var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrougelogoseb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 79.76 109.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{fill:#978c87;}.cls-4{fill:url(#Nouvelle_nuance_de_motif_3);}"), /*#__PURE__*/React.createElement("pattern", {
    id: "Nouvelle_nuance_de_motif_3",
    x: 0,
    y: 0,
    width: 94.07,
    height: 94.07,
    patternTransform: "translate(681.73 2245) scale(.89)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 94.07 94.07"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    width: 94.07,
    height: 94.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    width: 94.07,
    height: 94.07
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 79.76,
    height: 109.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.24,93.52h-5.56v-3.08h5.56c2.05,0,2.33,.74,2.33,1.54,0,.72-.26,1.54-2.33,1.54Zm-5.57-8.69h5.55c1.48,0,1.65,.73,1.65,1.29,0,1.01-.57,1.54-1.65,1.54h-5.55v-2.82Zm9.13,3.91c.47-.51,1.02-1.32,1.02-2.62,0-2.82-2.3-4.07-4.58-4.07h-8.48v14.26h8.48c3.19,0,5.25-1.7,5.25-4.33,0-1.57-.88-2.67-1.69-3.24Zm-22.94,1.54h8.62v-2.79h-8.62v-2.67h9.5v-2.79h-12.42v14.26h12.78v-2.79h-9.85v-3.24Zm-10.75-2.86h-1.86c-1.95,0-1.95-.78-1.95-1.11,0-1.3,2.12-1.77,3.55-1.77,1.96,0,2.9,.55,3.91,1.14l.78,.45,.24-.33,1.4-1.9-.37-.26c-1.81-1.26-3.83-1.89-6.01-1.89-3.11,0-6.42,1.6-6.42,4.56,0,2.65,2.39,3.86,4.62,3.86h2.1c2.17,0,3.96,.13,3.96,1.77,0,1.36-2.47,1.86-4.04,1.86-2.69,0-4.04-1-4.93-1.66l-.81-.58-.26,.26-1.76,1.61,.43,.4c.95,.89,2.93,2.75,7.2,2.75,3.53,0,7.09-1.43,7.09-4.63,0-3.01-2.31-4.54-6.87-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.56,78.32c0,1.09-1.21,1.78-2.82,1.78-1.72,0-3.4-.99-3.4-3.14,0-1.59,1.37-3.06,3.42-3.06,1.52,0,2.3,.76,2.67,1.1l-.5,.5c-.39-.33-1.11-.91-2.14-.91-1.66,0-2.72,1.15-2.72,2.36,0,1.43,1.06,2.44,2.7,2.44,1.36,0,2.06-.59,2.06-1.13v-.83h-2.15v-.7h2.88v1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.3,76.81c.83,0,1.49-.09,1.49-1.06,0-.74-.68-1.02-1.36-1.02h-2.81v2.08h2.68Zm2.07,3.17h-.84l-1.44-2.47h-2.47v2.47h-.73v-5.95h3.11c.94,0,2.52,.17,2.52,1.71,0,1.28-.86,1.7-1.6,1.77l1.45,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.83,79.41c1.5,0,2.62-1.09,2.62-2.4s-1.12-2.4-2.62-2.4-2.62,1.09-2.62,2.4,1.12,2.4,2.62,2.4Zm0-5.5c1.92,0,3.36,1.43,3.36,3.1s-1.44,3.1-3.36,3.1-3.36-1.43-3.36-3.1,1.43-3.1,3.36-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.07,77.67c0,1.52-.84,2.44-2.76,2.44s-2.76-.91-2.76-2.44v-3.64h.73v3.64c0,1.26,.7,1.74,2.02,1.74s2.02-.48,2.02-1.74v-3.64h.73v3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.48,76.73c.7,0,1.23-.21,1.23-1,0-.83-.6-1.01-1.23-1.01h-2.71v2.01h2.71Zm-2.71,3.24h-.73v-5.95h3.45c.77,0,1.96,.29,1.96,1.71,0,1.26-.87,1.7-1.96,1.7h-2.71v2.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.77 79.98 55.78 79.98 55.78 74.03 60.77 74.03 60.77 74.73 56.51 74.73 56.51 76.54 60.77 76.54 60.77 77.24 56.51 77.24 56.51 79.28 60.77 79.28 60.77 79.98"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.88 71.33 32.88 63.1 26.11 57.79 19.35 63.1 19.35 71.33 32.88 71.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.64,46.15c-9.73-2.68-13.06-3.7-13.06-7.59,0-3.11,2.49-5.3,6.08-5.38h.59c2.74,.06,4.84,1.35,5.68,3.34,.05,.12,.13,.3,.23,.61,.36,1.05,.47,2.12,.45,3.11v1.36h12.04V0h-12.44V23.28c-2.13-.64-4.23-.92-6.03-.92-11.16,0-18.57,7.73-18.88,16.02-.01,.26-.02,.52-.02,.79,0,10.71,7.69,14.26,14.9,16.75l.53,.18h0c.7,.23,1.39,.47,2.04,.69,6.38,2.14,12.48,4.05,12.48,9.57,0,1.95-.54,3.63-1.49,4.97h13.02c.5-1.79,.75-3.68,.75-5.65,0-14.86-13.73-18.67-16.87-19.53Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrougelogoseb);
export default __webpack_public_path__ + "static/media/CAR ROUGE LOGO SEB.2393f89cc3bce5bf5163d0a5cd3a4d1c.svg";
export { ForwardRef as ReactComponent };